"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrq = void 0;
const react_1 = __importDefault(require("react"));
exports.Arrq = (props) => {
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", viewBox: "0 0 6 7" }, props),
        react_1.default.createElement("path", { fill: "#fff", d: "M.964.712v5.563h.68v.712H0V0h1.645v.712H.964zM2.994 4.296c.385 0 .693.31.693.698a.693.693 0 01-.693.699c-.386 0-.681-.31-.681-.712 0-.4.295-.685.68-.685zM2.44 3.92V.48H3.56V3.92H2.44zM4.355.712V0H6v7H4.355v-.712h.681V.725h-.68V.712z" })));
};
